// extracted by mini-css-extract-plugin
module.exports = {"container":"CurrencyConverter_container__dyo3j"};